var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { UserPermissions, UserType } from "healthex-common/user.dtos";
import { computed } from "mobx";
import { NOT_LOADED } from "../../Infra/RemoteData";
import { NamedRoutes } from "../NamedRoutes";
export class GlobalAdminOrgDetailViewModel {
    constructor(container) {
        this.globalAdminUIManager = container.globalAdminUIManager;
        this.authManager = container.authManager;
        this.organizationsManager = container.organizationsManager;
        this.routingUIManager = container.routingUIManager;
    }
    get currentAdminPage() {
        return this.globalAdminUIManager.currentAdminPage;
    }
    setCurrentAdminPage(adminPage) {
        this.globalAdminUIManager.setCurrentAdminPage(adminPage);
    }
    get pageTitle() {
        var _a;
        if (this.globalAdminUIManager.adminType === null) {
            return null;
        }
        else {
            if (this.organizationsManager.organizations.value === NOT_LOADED)
                return "Global Admin";
            const organization = (_a = this.organizationsManager.organizations.value) === null || _a === void 0 ? void 0 : _a.find((candidate) => candidate.id === this.globalAdminUIManager.organizationIdToAdmin);
            return `Global Admin: ${organization === null || organization === void 0 ? void 0 : organization.name}`;
        }
    }
    get loginSettingsApplicable() {
        return (this.globalAdminUIManager.organizationTypeToAdmin === UserType.HEALTHCARE_ORGANIZATION &&
            this.authManager.permissions.includes(UserPermissions.ORG_ADMIN));
    }
    get researchConfigurationApplicable() {
        return (this.authManager.userType === UserType.HEALTHCARE_ORGANIZATION &&
            this.authManager.permissions.includes(UserPermissions.ORG_ADMIN));
    }
    get myOrgName() {
        return this.authManager.orgName;
    }
    get onBack() {
        if (this.globalAdminUIManager.adminType === null) {
            return undefined;
        }
        else {
            return () => this.routingUIManager.navigateTo(NamedRoutes.GLOBAL_ADMIN_ORGANIZATIONS);
        }
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], GlobalAdminOrgDetailViewModel.prototype, "currentAdminPage", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], GlobalAdminOrgDetailViewModel.prototype, "pageTitle", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], GlobalAdminOrgDetailViewModel.prototype, "loginSettingsApplicable", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], GlobalAdminOrgDetailViewModel.prototype, "researchConfigurationApplicable", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], GlobalAdminOrgDetailViewModel.prototype, "myOrgName", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], GlobalAdminOrgDetailViewModel.prototype, "onBack", null);
